var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"googleMap",staticClass:"google-map"}),_vm._v(" "),(Boolean(_vm.google) && Boolean(_vm.googleMap))?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }